<template>
   <div>
       Multi: {{object.id }} {{ object.objectable?.name }}
       <ul>
            <li v-for="p in object.objectable?.paragraphs" :key="p.id" class="mb-4">
                <ParagraphObject  :object="p" />
                <!-- <span v-if="p.content">
                    <div class="w-full flex flex-wrap items-center justify-start gap-3">
                        <div>
                            {{ p.name }} - {{p.id}}
                        </div>
                        <div>
                            <input type="number" v-model="p.order" class="p-2 w-20 bg-slate-700 text-slate-100 border" />
                        </div>
                        <div>
                            <input type="text" v-model="p.class" class="p-2 flex-1 bg-slate-700 text-slate-100 border" />
                        </div>
                    </div>
                    <textarea v-model="p.content" class="w-full md:w-3/4 min-h-64 p-2"  />
                    <div class="w-full">
                        <button @click="saveData(p.id, p.content, p.order, p.class)">SAVE</button>
                    </div>
                </span> -->
            </li>
       </ul>

   </div>
</template>

<script>
import ParagraphObject from './ParagraphObject.vue';
import ContentEditor from './ContentEditor.vue';
import { router } from '@inertiajs/vue3';

export default {
   name: "MultiParagrapher",
   props: ['object'],
   components: { ContentEditor, ParagraphObject },
   computed: {},
   data() {
       return {

       }
   },
   mounted() {

   },
   methods: {
        saveData(id, content, order, classes) {
            router.post('/post-content', {id: id, content: content, order: order, class: classes});
        },
        findObjectable(k, p) {
            return k == 'objectable' ? p : null;
        }
   }
}
</script>

